let env = {};

// env.baseURL = 'http://api.ama-doroteia.ares-saude.com.br/api/v1/';
// env.normalURL = 'http://api.ama-doroteia.ares-saude.com.br/';
// env.webserviceHost = '179.190.28.108';
// env.webservicePort = '6001';

// env.baseURL = 'http://api.triagem.ares-saude.com.br/api/v1/';
// env.normalURL = 'http://api.triagem.ares-saude.com.br/';
// env.webserviceHost = '179.190.28.108';
// env.webservicePort = '6001';

// env.baseURL = 'http://api.triagem-sp.ares-saude.com.br/api/v1/';
// env.normalURL = 'http://api.triagem-sp.ares-saude.com.br/';
// env.webserviceHost = '179.190.28.108';
// env.webservicePort = '6001';

//UPA ICARAI
env.baseURL = 'https://api.upaicarai.ares-triagem.com.br/api/v1/';
env.normalURL = 'https://api.upaicarai.ares-triagem.com.br/';
env.webserviceHost = 'websocket.upaicarai.ares-triagem.com.br';
env.webservicePort = '';


// env.baseURL = 'http://localhost:8000/api/v1/';
// env.normalURL = 'http://localhost:8000/';
// env.webserviceHost = 'localhost';
// env.webservicePort = '6001';

// env.baseURL = 'https://api.triagem-hml.ares-saude.com.br/api/v1/';
// env.normalURL = 'https://api.triagem-hml.ares-saude.com.br/';
// env.wsHost = '54.207.61.51';
// env.wsPort = '6001';

export default env
